import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config.js';

/*
  En sam klient za cel app.

  Testi ga zamenjajo prek window.__SUPABASE_MOCK__ — tako smoke testi
  tečejo brez prave baze in brez Google prijave, hkrati pa produkcijska
  koda nima nobene testne veje.
*/
export const sb =
  typeof window !== 'undefined' && window.__SUPABASE_MOCK__
    ? window.__SUPABASE_MOCK__
    : createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
      });
